import { WorkflowEtapaTipo } from '../models/workflow.models';

export const WORKFLOW_ETAPAS = [
  { tipo: WorkflowEtapaTipo.ABERTURA_OS, nome: 'Abertura de OS' },
  { tipo: WorkflowEtapaTipo.COMPRA_PECAS, nome: 'Compra de Peças' },
  { tipo: WorkflowEtapaTipo.PROGRAMACAO_REPARO, nome: 'Programação do Reparo' },
  { tipo: WorkflowEtapaTipo.DESMONTAGEM, nome: 'Desmontagem' },
  { tipo: WorkflowEtapaTipo.ANALISE_COMPLEMENTO, nome: 'Análise de Complemento' },
  { tipo: WorkflowEtapaTipo.FUNILARIA, nome: 'Funilaria' },
  { tipo: WorkflowEtapaTipo.PREPARACAO, nome: 'Preparação' },
  { tipo: WorkflowEtapaTipo.PINTURA, nome: 'Pintura' },
  { tipo: WorkflowEtapaTipo.MECANICA, nome: 'Mecânica' },
  { tipo: WorkflowEtapaTipo.MONTAGEM, nome: 'Montagem' },
  { tipo: WorkflowEtapaTipo.POLIMENTO, nome: 'Polimento' },
  { tipo: WorkflowEtapaTipo.LAVAGEM, nome: 'Lavagem / Higienização' },
  { tipo: WorkflowEtapaTipo.ACABAMENTO, nome: 'Acabamento' },
  { tipo: WorkflowEtapaTipo.CONTROLE_QUALIDADE, nome: 'Controle Qualidade Final' },
  { tipo: WorkflowEtapaTipo.VISTORIA_SEGURADORA, nome: 'Fotos / Vistoria Seguradora' },
  { tipo: WorkflowEtapaTipo.FINALIZADO, nome: 'Finalizado' },
];

export const WORKFLOW_ETAPA_INDEX = new Map(
  WORKFLOW_ETAPAS.map((etapa, index) => [etapa.tipo, index])
);
